import './node-summary-info-table.style.scss'

class nodeSummaryInfoTableController {

}

export default nodeSummaryInfoTableController;



// WEBPACK FOOTER //
// ./ui/src/components/node-summary-info-table/node-summary-info-table.controller.js